import { NextRouter } from 'next/router'
import { Route } from 'nextjs-routes'

type Trick<T extends Route['pathname']> = T

export const isExactRoute = <T extends Route['pathname']>(
  router: NextRouter<any>,
  route: T,
): router is T extends Trick<infer R> ? NextRouter<R> : never => router.pathname === route
